/** Кука `tz` — пояс браузера для времени сброса в отказе лимита (docs/billing_limits.md §10.1). */
export function writeTimeZoneCookie(maxAge: number) {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (!tz) return
    document.cookie = `tz=${tz};path=/;max-age=${maxAge};samesite=lax`
  } catch {
    /* SSR / private mode */
  }
}
